{
    "Profile_Renewal_Header.renewalReview": "FR: Renewal Review",
    "Profile_Renewal_Header.createRenewal": "FR: Create a Renewal",
    "Profile_Renewal_Header.bound": "FR: Bound",
    "Profile_Renewal_Header.youreAllSet": "FR: You're all set!",
    "Profile_Renewal_Header.renewalPolicy": "FR: Renewal Policy",
    "Profile_Renewal_Header.welcome": "FR: Welcome",
    "Profile_Renewal_Header.subHeader": "FR: Here is your policy renewal information"
}
